var setAriaAttribute = function(bt, value) {
  if(!bt.hasAttribute('aria-expanded')) { return false; }

  const strValue = value ? 'true' : 'false';
  bt.setAttribute('aria-expanded', strValue);
};

export default setAriaAttribute;
